import React from 'react';
import { Mail, Phone, MapPin, Instagram, MessageCircle, Youtube } from 'lucide-react';
import { siteInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-logo-container">
        <img
          src={siteInfo.logoUrl}
          alt={siteInfo.name}
          className="footer-logo"
        />
      </div>
      <p className="footer-tagline">Especialistas en Importación de Jeep Wrangler</p>
      <div className="footer-divider" />
      <div className="footer-contact">
        <div className="footer-contact-item">
          <Mail size={18} color="#D70000" />
          <span>{siteInfo.email}</span>
        </div>
        <div className="footer-contact-item">
          <Phone size={18} color="#D70000" />
          <span>{siteInfo.phone}</span>
        </div>
        <div className="footer-contact-item">
          <MapPin size={18} color="#D70000" />
          <span>{siteInfo.location}</span>
        </div>
      </div>
      <div className="footer-social">
        <a href="#" className="social-icon-btn" aria-label="Instagram">
          <Instagram size={24} color="#1A1A1A" />
        </a>
        <a href="#" className="social-icon-btn" aria-label="WhatsApp">
          <MessageCircle size={24} color="#1A1A1A" />
        </a>
        <a href="#" className="social-icon-btn" aria-label="YouTube">
          <Youtube size={24} color="#1A1A1A" />
        </a>
      </div>
      <p className="footer-copyright">{siteInfo.copyright}</p>
    </footer>
  );
};

export default Footer;
